<div class="modal-content">
  <!-- Modal Header -->
  <div class="modal-header">
    <div class="header-content">
      <h3 class="modal-title">{{ form_header || modalTitle }}</h3>
      <div class="header-icons">
        <i class="fa minimize-icon"
           [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
           (click)="minimise = !minimise"></i>
        <i class="fa fa-times close-icon" (click)="cancel()"></i>
      </div>
    </div>
  </div>

  <!-- Modal Body -->
  <div class="modal-body" [class.collapsed]="minimise">
    <!-- Loading Spinner -->
    @if (dataLoading) {
<div class="loading-container">
      <i class="fa fa-spinner fa-spin loading-icon"></i>
      <div class="loading-text">Loading Schedule J data...</div>
    </div>
}

    @if (!dataLoading) {
<div class="schedule-j-container">
      <div class="col-md-12">
        <h4>
          <i class="fa fa-info-circle"></i>
          {{ table_header || 'All amounts in U. S. Dollars' }}
        </h4>
      </div>

      <!-- Part I Table (or single table for tax_year < 2018) -->
      <table class="table table-bordered schedule-table">
        <thead>
          @if (partHeader.length > 0) {
<tr>
            <th [attr.colspan]="columnSubHeader.length + 2">
              <h4><b>{{ partHeader[0] }}</b></h4>
            </th>
          </tr>
}
          <tr>
            @for (header of columnHeader; track $index) {
<th
                [attr.rowspan]="header.row_span_value"
                [attr.colspan]="header.col_span_value"
                class="text-center">{{ header.header_value }}</th>
}
          </tr>
          @if (columnSubHeader.length > 0) {
<tr>
            @for (subHeader of columnSubHeader; track $index) {
<th class="text-center">{{ subHeader }}</th>
}
          </tr>
}
        </thead>
        <tbody>
          @for (line of getPartILines(); track trackByLineNo($index, line)) {
<tr style="background: #f9f9f9;">
            <td style="width: 40px" class="text-center">
              {{ partFlag ? splitLineNo(line.line_no, '-', 1) : line.line_no }}
            </td>
            <td>{{ line.line_Description }}</td>
            @for (column of line.column_description; track trackByIndex($index)) {
<td
                class="text-right"
                [ngStyle]="column.column_style">
              @if (column.is_Display) {
<div>
                @if (!column.is_editable) {
<div>{{ (column.VALUE | number) || 0 }}</div>
}
                @if (column.is_editable) {
<div>
                  <input type="text"
                         [(ngModel)]="column.VALUE"
                         class="text-right form-control input-sm numText"
                         placeholder="0"
                         (ngModelChange)="onFieldChange(line.line_no, line.part_no)">
                </div>
}
              </div>
}
            </td>
}
          </tr>
}
        </tbody>
      </table>

      <!-- Part II Table (only for tax_year >= 2018) -->
      @if (partHeader.length > 1) {
<div>
        <table class="table table-bordered schedule-table">
          <thead>
            <tr>
              <th [attr.colspan]="columnHeader.length + 2">
                <h4><b>{{ partHeader[1] }}</b></h4>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (line of getPartIILines(); track trackByLineNo($index, line)) {
<tr style="background: #f9f9f9;">
              <td style="width: 40px" class="text-center">
                {{ splitLineNo(line.line_no, '-', 1) }}
              </td>
              <td>{{ line.line_Description }}</td>
              @for (column of line.column_description; track trackByIndex($index)) {
<td
                  class="text-right"
                  [ngStyle]="column.column_style">
                @if (column.is_Display) {
<div>
                  @if (!column.is_editable) {
<div>{{ (column.VALUE | number) || 0 }}</div>
}
                  @if (column.is_editable) {
<div>
                    <input type="text"
                           [(ngModel)]="column.VALUE"
                           class="text-right form-control input-sm numText"
                           placeholder="0"
                           (ngModelChange)="onFieldChange(line.line_no, line.part_no)">
                  </div>
}
                </div>
}
              </td>
}
            </tr>
}
          </tbody>
        </table>
      </div>
}

      <!-- Error Message -->
      @if (userMessage) {
<div class="alert alert-warning">
        {{ userMessage }}
      </div>
}
    </div>
}
  </div>

  <!-- Footer Actions -->
  <div class="modal-footer">
    <button class="btn btn-info btn-sm" type="button" (click)="saveScheduleJData()" [disabled]="crudLoading">
      @if (crudLoading) {
<span>
        <i class="fa fa-spinner fa-pulse"></i>
      </span>
}
      Save
    </button>
    <button class="btn btn-danger-outline btn-sm" type="button" (click)="restoreGHOSTAmt()">Restore GHOST Amount</button>
    <button class="btn btn-danger-outline btn-sm" type="button" (click)="reset()">Reset</button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>
